import React from 'react';
import { Text } from '@chatsdet/ui';
import type { SinceBoxData } from '../../../features/digests/overview';
import { toneClass } from './DigestHeadlinePanel';

/**
 * Dividers are placed per cell from its index: Tailwind's `divide-*` borders
 * every sibling after the first in DOM order, which leaks stray edges once the
 * grid wraps. Two columns below `md`, three from `md`, six from `xl`.
 */
function cellBorders(index: number): string {
  return [
    'border-border',
    index % 2 === 1 ? 'border-l' : '',
    index >= 2 ? 'border-t' : '',
    // md: three columns
    index % 3 === 0 ? 'md:border-l-0' : 'md:border-l',
    index >= 3 ? 'md:border-t' : 'md:border-t-0',
    // xl: one row of six
    index === 0 ? 'xl:border-l-0' : 'xl:border-l',
    'xl:border-t-0',
  ]
    .filter(Boolean)
    .join(' ');
}

/** One bordered group of stat cells: small label, large value, muted sub-line. */
export function DigestSinceStats({ boxes }: { boxes: SinceBoxData[] }) {
  return (
    <div className="overflow-hidden rounded-lg border border-border bg-card">
      <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6">
        {boxes.map((box, index) => (
          <div key={box.key} className={`${cellBorders(index)} px-4 py-4`}>
            <Text size="xs" className="block text-balance uppercase tracking-wide text-muted-foreground">
              {box.label}
            </Text>
            <Text className="mt-1 text-2xl font-semibold leading-tight tabular-nums">{box.value}</Text>
            {box.sub && (
              <Text size="xs" className={`mt-0.5 text-pretty tabular-nums ${toneClass[box.subTone]}`}>
                {box.sub}
              </Text>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
